import React from "react";
import "./LenderRow.scss";
import {BrandContext} from "src/modules/brand/BrandContext";
import {BrandConfig} from "src/modules/brand/BrandConfig";
import {resolveLogoUrl} from "src/modules/brand/readBrandConfig";

/**
 * The lender's identity on the payment tile.
 *
 * Sits directly above the SIMPL home block, low on the tile, so simpl. stays the dominant mark:
 * product first, lender second, platform and license last.
 *
 * The logo is placed on a white chip rather than reversed out. Lender logos arrive full-color
 * and unknown — Triumph's is grey, Vista's terracotta — and a white chip keeps any of them
 * legible on any brand surface, so lenders never have to supply a reversed version.
 *
 * Renders nothing for the default platform brand, which has no separate lender to name.
 */
export class LenderRow extends React.Component {

    static contextType = BrandContext;
    context!: BrandConfig;

    render() {
        const brand = this.context;
        // The platform brand has no separate lender to name — showing a row here would just
        // repeat the home block directly beneath it. An absent flag is treated as the platform.
        if (brand.isDefault !== false) return null;
        if (!brand.logoUrl && !brand.displayName) return null;

        return (
            <div className="lender-row">
                <div className="lender-row__label">Your loan is with</div>
                {brand.logoUrl
                    ? <div className="lender-row__chip">
                        <img src={resolveLogoUrl(brand.logoUrl)} alt={brand.displayName}/>
                      </div>
                    : <div className="lender-row__name">{brand.displayName}</div>}
                {brand.relationshipLine
                    ? <div className="lender-row__legal">{brand.relationshipLine}</div>
                    : null}
            </div>
        );
    }
}
